import './i18n';
import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./App";
import KYCOnboardingPortal from "./KYCOnboardingPortal";
import { C, LIGHT, ThemeContext } from "./theme";

const params = new URLSearchParams(window.location.search);
const isKYCPortal = params.get("kyc") === "1";
const portalCompanyId = params.get("company") || null; // company UUID from URL

// Theme Provider for all routes
function RootLayout() {
  const [lightMode, setLightMode] = useState(
    () => localStorage.getItem("crossregguard_theme") === "light"
  );
  const T = lightMode ? LIGHT : C;

  return (
    <ThemeContext.Provider value={T}>
      <Routes>
        {/* NexusGuard and Training are separate independent platforms served from their own dist folders */}
        <Route
          path="*"
          element={
            isKYCPortal ? (
              <KYCOnboardingPortal companyId={portalCompanyId} />
            ) : (
              <App />
            )
          }
        />
      </Routes>
    </ThemeContext.Provider>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <RootLayout />
    </Router>
  </React.StrictMode>
);